/**
 * FieldTypeSection — optional sub-group header (Measures / Dimensions / Dates).
 *
 * Only rendered when an entity has mixed field types.
 * Small muted label followed by children field items.
 */
import { makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  label: {
    padding: "6px 12px 2px 20px",
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    letterSpacing: "0.3px",
  },
});

interface FieldTypeSectionProps {
  label: string;
  children: React.ReactNode;
}

export default function FieldTypeSection({ label, children }: FieldTypeSectionProps) {
  const styles = useStyles();
  return (
    <div>
      <div className={styles.label}>{label}</div>
      {children}
    </div>
  );
}
